// language=GraphQL
export const ALL_FORM_BLOCKS_QUERY = `query Query {
  formBlocks: cmsFormBlocks {
    id
    formName
  }
}`

// language=GraphQL
export const SINGLE_FORM_BLOCK_QUERY = `query Query($id: ID!) {
  formBlock: cmsFormBlock(id: $id) {
    id
    formName
  }
}`

// language=GraphQL
export const CREATE_FORM_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsFormBlockInput) {
    formBlock: createCmsFormBlock(input: $input) {
      id
      formName
    }
  }`

// language=GraphQL
export const UPDATE_FORM_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsFormBlockInput) {
    formBlock: updateCmsFormBlock(input: $input) {
      id
      formName
    }
  }`

// language=GraphQL
export const DELETE_FORM_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsFormBlockInput) {
    deleteCmsFormBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_FORM_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsFormBlockInput) {
    forceDeleteCmsFormBlock(input: $input) {
      success
    }
  }`
